import React from "react";
import CardioIconSvg from "../../../../../../../common/svgs/CardioIconSvg";
import IntervalIconSvg from "../../../../../../../common/svgs/IntervalIconSvg";
import ResistanceIconSvg from "../../../../../../../common/svgs/ResistanceIconSvg";
import RestDayIconSvg from "../../../../../../../common/svgs/RestDayIconSvg";
import { WORKOUT_TYPE } from "../../model/workoutEnums";

type Props = {
  type: number;
  fill: string;
  size?: number;
};

/** The mobile `getWorkoutIcon`: one glyph per workout type (the dashboard's Daily Log uses the same SVGs). */
const WorkoutTypeIcon = ({ type, fill, size = 12 }: Props) => {
  switch (type) {
    case WORKOUT_TYPE.Interval:
      return <IntervalIconSvg fill={fill} width={size} height={size} />;
    case WORKOUT_TYPE.Resistance:
      return <ResistanceIconSvg fill={fill} width={size} height={size} />;
    case WORKOUT_TYPE.Cardio:
      return <CardioIconSvg fill={fill} width={size} height={size} />;
    case WORKOUT_TYPE.RestDay:
      return <RestDayIconSvg fill={fill} width={size} height={size} />;
    default:
      return null;
  }
};

export default WorkoutTypeIcon;
